// extracted by mini-css-extract-plugin
export default {"zoomButton":"ZoomButton_zoomButton__MljMs","zoomIcon":"ZoomButton_zoomIcon__Tnlxw","zoomText":"ZoomButton_zoomText__adQYp"};